module.exports = __webpack_public_path__ + "img/logoAnimado.ea1fba83.gif";